// cookie的操作
/*设置cookie
 *@method   setCookie 
 *@param    {str}   name    cookie的名字
 *@param    {str}   value   该cookie对应的值
 *@param    {str}   hours   返回的时间戳 默认为1
 */
function setCookie(name, value, hours = 1) {
	hours = hours + 8 * 60 * 60 * 1000;
	if (document.domain.indexOf('lshoot.com') != -1) {
	  document.cookie = name + "=" + encodeURIComponent(value) + ';expires=' + new Date(hours).toGMTString() + ';domain=.lshoot.com;path=/';
	} else {
	  document.cookie = name + "=" + encodeURIComponent(value) + ';expires=' + new Date(hours).toGMTString() + ';path=/';
	}
	// var Days = 1;
	// var exp = new Date();
	// exp.setTime(exp.getTime() + Days*24*60*60*1000);
	// document.cookie = name + "="+ encodeURIComponent (value) + ";expires=" + exp.toGMTString();
  }
  
  /*读取cookie
   *@method   getCookie 
   *@param    {str}   name    cookie的名字
   * @return   {str}   null 或 cookie的值
   */
  function getCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	if (arr = document.cookie.match(reg))
	  return decodeURIComponent(arr[2]);
	else
	  return null;
  }
  
  /*删除cookie
   *@method   setCookie 
   *@param    {str}   name    cookie的名字
   */
  function delCookie(name) {
	var exp = new Date();
	exp.setTime(exp.getTime() - 1);
	var cval = getCookie(name);
	if (cval != null) {
	  if (document.domain.indexOf('lshoot.com') != -1) {
		document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ';domain=.lshoot.com;path=/';
	  } else {
		document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ';path=/';
	  }
	}
  
  }

// 导出
export { setCookie, getCookie, delCookie }


// WEBPACK FOOTER //
// ./src/assets/js/cookie.js